import { clx, Label } from '@medusajs/ui';
import { ComponentProps } from 'react';

export enum DiscountLabelKind {
  Promotion = 'Promotion',
  Giveaway = 'Giveaway',
  FreeShipping = 'FREESHIPPING5000',
  Other = 'Other',
}

type DiscountLabelProps = Omit<ComponentProps<typeof Label>, 'size'> & {
  kind: DiscountLabelKind;
};

export const DiscountLabel = ({
  className,
  children,
  kind,
  ...props
}: DiscountLabelProps) => (
  <Label
    {...props}
    size="base"
    className={clx(
      'inline-flex h-[30px] w-[72px] items-center justify-center rounded-md font-bold',
      {
        'bg-orange-30_op10 text-orange-30':
          kind === DiscountLabelKind.Promotion,
        'bg-purple-30_op10 text-purple-30': kind === DiscountLabelKind.Giveaway,
        'bg-blue-30_op10 text-blue-30': kind === DiscountLabelKind.FreeShipping,
        'bg-white-40 text-black-10': kind === DiscountLabelKind.Other,
      },
      className
    )}
  >
    {children}
  </Label>
);
